import type { MorphemeDetailsTileSlice } from "@-/dev.improve.haniverse.lib.morpheme.entities";

/** Character glosses are bold, mnemonic-only glosses italic, and other definitions regular. */
export function morphemeGlossEmphasisClassName(graphemeCard: MorphemeDetailsTileSlice): string {
  const hasCardGloss = Boolean(graphemeCard.back);
  if (
    hasCardGloss &&
    graphemeCard.morphemeType === "grapheme" &&
    graphemeCard.label === "mnemonic"
  ) {
    return "font-normal italic";
  }
  if (hasCardGloss && graphemeCard.morphemeType === "grapheme") {
    return "font-bold";
  }
  return "font-normal";
}
